import {
    Component,
    OnInit,
    OnDestroy,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import * as _ from "lodash";
import moment from "moment";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Observable, Subject, Subscriber } from "rxjs";
import { switchMap, takeUntil } from "rxjs/operators";
import { NbcLoggerService } from "src/app/shared/logger/nbc-logger.service";
import { SubSink } from "subsink";
import { EventBusService } from "../../../core/services/event-bus.service";
import { NbcFileDownloadComponent } from "../../../shared/component/nbc-file-download/nbc-file-download.component";
import { BusinessUnitService } from "../../../shared/services/business-unit.service";
import { GlobalService } from "../../../shared/services/global.service";
import { LookUpService } from "../../../shared/services/lookup.service";
import { SharedDataService } from "../../../shared/sharedData.service";

@Component({
    selector: "transaction-report",
    templateUrl: "./transaction-report.component.html",
    standalone: false
})
export class TransactionReportComponent implements OnInit, OnDestroy {
    constructor(
        private _eventBus: EventBusService,
        private _sharedDataService: SharedDataService,
        public bsModalRef: BsModalRef,
        private _globalService: GlobalService,
        private businessUnitService: BusinessUnitService,
        private _lookupService: LookUpService,
        private log: NbcLoggerService
    ) {}

    reportName;

    showDateRangeRowAll = true;
    showDateRangeEditRow = false;
    showDateRangeTagRow = false;

    showEventShowRowAll = true;
    showEventShowEditRow = false;
    showEventShowTagRow = false;

    showContactRowAll = true;
    showContactEditRow = false;
    showContactTagRow = false;

    showDayTypeRowAll = true;
    showDayTypeEditRow = false;
    showDayTypeTagRow = false;

    showNetworksRowAll = true;
    showNetworksEditRow = false;
    showNetworksTagRow = false;

    showBURowAll = false;
    showBUEditRow = false;
    showBUTagRow = true;

    showSportsRowAll = true;
    showSportsEditRow = false;
    showSportsTagRow = false;

    showWbseRowAll = true;
    showWbseEditRow = false;
    showWbseTagRow = false;

    showGlAccountRowAll = true;
    showGlAccountEditRow = false;
    showGlAccountTagRow = false;

    showEmployeeTypeRowAll = true;
    showEmployeeTypeEditRow = false;
    showEmployeeTypeTagRow = false;

    showUnionCodeRowAll = true;
    showUnionCodeEditRow = false;
    showUnionCodeTagRow = false;

    showProcessedDateRangeRowAll = true;
    showProcessedDateRangeEditRow = false;
    showProcessedDateRangeTagRow = false;

    showAftraRowAll = true;
    showAftraEditRow = false;
    showAftraTagRow = false;

    unionCodeList: any = [];
    selectedUnionCode: any = [];
    employeeTypeList: any = [];
    selectedEmployeeType: any = [];
    networksList: any = [];
    dayTypeList: any = [];
    selectedNetwork: any = [];
    selectedDayType: any = [];
    selectedBU: any = [];
    sportList: any = [];
    selectedSport: any = [];
    exportDisable: any = true;
    contactFilter: any = null;
    selectedAftra: any[] = [];
    selectedAftraItem: any = {};

    showAlertMessage: any;
    alerts: any;
    query: any;

    transactionSummaryquery: any;
    networks: any[] = [];
    daytypes: any[] = [];
    businessUnits: any[] = [];
    allBusinessUnits: any[] = [];
    employeetypes: any[] = [];
    sport: any[] = [];
    unioncodes: any[] = [];
    glAccountObservable$: Observable<any[]> | undefined;
    contactNameObservable$: Observable<any[]> | undefined;
    glAccountSearchTerm: string | undefined;
    componentDestroyed$: Subject<boolean> = new Subject();
    //businessUnits: any;
    selectedDepartmentId: any;
    @ViewChild(NbcFileDownloadComponent) child;
    isDownload = false;
    selectedBusinessUnit: any;
    departmentId: any;
    businessUnitId: any;
    selectedBuAccess: any;
    buAccess: any;

    AftraList: any = [
      { description: 'Yes', id: true },
      { description: 'No', id: false }
    ];

    private subs = new SubSink();

    cancel() {
        // $modalInstance.close();
        this.bsModalRef.hide();
    }

    closeAlert() {
        this.alerts = [];
        this.showAlertMessage = false;
    }

    editRow(value) {
        switch (value) {
            case "ContactRow":
                {
                    this.showContactRowAll = false;
                    this.showContactEditRow = true;
                    this.showContactTagRow = false;
                }
                break;

            case "EventShowRow":
                {
                    this.showEventShowRowAll = false;
                    this.showEventShowEditRow = true;
                    this.showEventShowTagRow = false;
                }
                break;
            case "DateRangeRow":
                {
                    this.showDateRangeRowAll = false;
                    this.showDateRangeEditRow = true;
                    this.showDateRangeTagRow = false;
                }
                break;
            case "NetworksRow":
                {
                    this.showNetworksRowAll = false;
                    this.showNetworksEditRow = true;
                    this.showNetworksTagRow = false;
                }
                break;
            case "DayTypeRow":
                {
                    this.showDayTypeRowAll = false;
                    this.showDayTypeEditRow = true;
                    this.showDayTypeTagRow = false;
                }
                break;
            case "SportsRow":
                {
                    this.showSportsRowAll = false;
                    this.showSportsEditRow = true;
                    this.showSportsTagRow = false;
                }
                break;
            case "WbseRow":
                {
                    this.showWbseRowAll = false;
                    this.showWbseEditRow = true;
                    this.showWbseTagRow = false;
                }
                break;
            case "GlaccountRow":
                {
                    this.showGlAccountRowAll = false;
                    this.showGlAccountEditRow = true;
                    this.showGlAccountTagRow = false;
                }
                break;
            case "EmployeeTypeRow":
                {
                    this.showEmployeeTypeRowAll = false;
                    this.showEmployeeTypeEditRow = true;
                    this.showEmployeeTypeTagRow = false;
                }
                break;
            case "UnionCodeRow":
                {
                    this.showUnionCodeRowAll = false;
                    this.showUnionCodeEditRow = true;
                    this.showUnionCodeTagRow = false;
                }
                break;
            case "BURow":
                {
                    this.showBURowAll = false;
                    this.showBUEditRow = true;
                    this.showBUTagRow = false;
                }
                break;
            case "ProcessedDateRangeRow":
                {
                    this.showProcessedDateRangeRowAll = false;
                    this.showProcessedDateRangeEditRow = true;
                    this.showProcessedDateRangeTagRow = false;
                }
                break;

          case "AftraRow":
            {
              this.showAftraRowAll = false;
              this.showAftraEditRow = true;
              this.showAftraTagRow = false;
            }
            break;
        }
    }

    confirmSelection(value, item?) {
        if (value === "ContactRow") {
            this.showContactEditRow = false;
            this.showSection(value);
        }
        if (value === "EventShowRow") {
            this.showEventShowEditRow = false;
            this.showSection(value);
        }
        if (value === "DateRangeRow") {
            this.showDateRangeEditRow = false;
            this.showSection(value);
        }
        if (value === "NetworksRow") {
            this.showNetworksEditRow = false;
            this.showSection(value);
        }
        if (value === "DayTypeRow") {
            this.showDayTypeEditRow = false;
            this.showSection(value);
        }
        if (value === "BURow") {
            this.showBUEditRow = false;
            this.showSection(value);
        }
        if (value === "SportsRow") {
            this.showSportsEditRow = false;
            this.showSection(value);
        }
        if (value === "WbseRow") {
            this.showWbseEditRow = false;
            this.showSection(value);
        }
        if (value === "GlaccountRow") {
            this.showGlAccountEditRow = false;
            this.showSection(value);
        }
        if (value === "EmployeeTypeRow") {
            this.showEmployeeTypeEditRow = false;
            this.showSection(value);
        }
        if (value === "UnionCodeRow") {
            this.showUnionCodeEditRow = false;
            this.showSection(value);
        }
        if (value === "ProcessedDateRangeRow") {
            this.showProcessedDateRangeEditRow = false;
            this.showSection(value);
        }
        if (value === "AftraRow") {
          this.showAftraEditRow = false;
          this.showSection(value);
        }
      
    }

    showSection(value) {
        switch (value) {
            case "DateRangeRow":
                {
                    if (
                        this.transactionSummaryquery.dateRangeStartDate !==
                            null &&
                        this.transactionSummaryquery.dateRangeEndDate !== null
                    ) {
                        this.showDateRangeRowAll = false;
                        this.showDateRangeEditRow = false;
                        this.showDateRangeTagRow = true;
                    } else {
                        this.showDateRangeRowAll = true;
                        this.showDateRangeEditRow = false;
                        this.showDateRangeTagRow = false;
                    }
                }
                break;

            case "ProcessedDateRangeRow":
                {
                    if (
                        this.transactionSummaryquery
                            .processDateRangeStartDate !== null &&
                        this.transactionSummaryquery.processDateRangeEndDate !==
                            null
                    ) {
                        this.showProcessedDateRangeRowAll = false;
                        this.showProcessedDateRangeEditRow = false;
                        this.showProcessedDateRangeTagRow = true;
                    } else {
                        this.showProcessedDateRangeRowAll = true;
                        this.showProcessedDateRangeEditRow = false;
                        this.showProcessedDateRangeTagRow = false;
                    }
                }
                break;
            case "UnionCodeRow":
                {
                    if (
                        this.selectedUnionCode &&
                        this.selectedUnionCode.length > 0
                    ) {
                        this.showUnionCodeRowAll = false;
                        this.showUnionCodeEditRow = false;
                        this.showUnionCodeTagRow = true;
                    } else {
                        this.showUnionCodeRowAll = true;
                        this.showUnionCodeEditRow = false;
                        this.showUnionCodeTagRow = false;
                    }
                }
                break;
            case "EmployeeTypeRow":
                {
                    if (
                        this.selectedEmployeeType &&
                        this.selectedEmployeeType.length > 0
                    ) {
                        this.showEmployeeTypeRowAll = false;
                        this.showEmployeeTypeEditRow = false;
                        this.showEmployeeTypeTagRow = true;
                    } else {
                        this.showEmployeeTypeRowAll = true;
                        this.showEmployeeTypeEditRow = false;
                        this.showEmployeeTypeTagRow = false;
                    }
                }
                break;
            case "SportsRow":
                {
                    if (this.selectedSport && this.selectedSport.length > 0) {
                        this.showSportsRowAll = false;
                        this.showSportsEditRow = false;
                        this.showSportsTagRow = true;
                    } else {
                        this.showSportsRowAll = true;
                        this.showSportsEditRow = false;
                        this.showSportsTagRow = false;
                    }
                }
                break;
            case "DayTypeRow":
                {
                    if (
                        this.selectedDayType &&
                        this.selectedDayType.length > 0
                    ) {
                        this.showDayTypeRowAll = false;
                        this.showDayTypeEditRow = false;
                        this.showDayTypeTagRow = true;
                    } else {
                        this.showDayTypeRowAll = true;
                        this.showDayTypeEditRow = false;
                        this.showDayTypeTagRow = false;
                    }
                }
                break;
            case "NetworksRow":
                {
                    if (
                        this.selectedNetwork &&
                        this.selectedNetwork.length > 0
                    ) {
                        this.showNetworksRowAll = false;
                        this.showNetworksEditRow = false;
                        this.showNetworksTagRow = true;
                    } else {
                        this.showNetworksRowAll = true;
                        this.showNetworksEditRow = false;
                        this.showNetworksTagRow = false;
                    }
                }
                break;
            case "BURow":
                {
                    if (this.selectedBU && this.selectedBU.length > 0) {
                        this.showBURowAll = false;
                        this.showBUEditRow = false;
                        this.showBUTagRow = true;
                    } else {
                        this.showBURowAll = true;
                        this.showBUEditRow = false;
                        this.showBUTagRow = false;
                    }
                }
                break;
            case "ContactRow":
                {
                    if (
                        this.transactionSummaryquery.contact &&
                        this.transactionSummaryquery.contact !== null
                    ) {
                        this.showContactRowAll = false;
                        this.showContactEditRow = false;
                        this.showContactTagRow = true;
                    } else {
                        this.showContactRowAll = true;
                        this.showContactEditRow = false;
                        this.showContactTagRow = false;
                    }
                }
                break;
            case "GlaccountRow":
                {
                    if (
                        this.transactionSummaryquery.glAccount &&
                        this.transactionSummaryquery.glAccount !== null
                    ) {
                        this.showGlAccountRowAll = false;
                        this.showGlAccountEditRow = false;
                        this.showGlAccountTagRow = true;
                    } else {
                        this.showGlAccountRowAll = true;
                        this.showGlAccountEditRow = false;
                        this.showGlAccountTagRow = false;
                    }
                }
                break;
            case "WbseRow":
                {
                    if (
                        this.transactionSummaryquery.wbseCostCenter &&
                        this.transactionSummaryquery.wbseCostCenter !== null
                    ) {
                        this.showWbseRowAll = false;
                        this.showWbseEditRow = false;
                        this.showWbseTagRow = true;
                    } else {
                        this.showWbseRowAll = true;
                        this.showWbseEditRow = false;
                        this.showWbseTagRow = false;
                    }
                }
                break;

            case "EventShowRow":
                {
                    if (
                        this.transactionSummaryquery.eventShow &&
                        this.transactionSummaryquery.eventShow !== null
                    ) {
                        this.showEventShowRowAll = false;
                        this.showEventShowEditRow = false;
                        this.showEventShowTagRow = true;
                    } else {
                        this.showEventShowRowAll = true;
                        this.showEventShowEditRow = false;
                        this.showEventShowTagRow = false;
                    }
                }
                break;

            case "AftraRow":
              {
              if (this.selectedAftra && this.selectedAftra.length > 0) {
                  this.showAftraRowAll = false;
                  this.showAftraEditRow = false;
                  this.showAftraTagRow  = true;
                } else {
                this.showAftraRowAll = true;
                this.showAftraEditRow = false;
                this.showAftraTagRow = false;
                }
              }
              break;
        }
        this.validForm();
    }

    removeDateTag(value) {
        if (value === "DateRangeRow") {
            this.transactionSummaryquery.dateRangeStartDate = null;
            this.transactionSummaryquery.dateRangeEndDate = null;
            this.showDateRangeRowAll = true;
            this.showDateRangeEditRow = false;
            this.showDateRangeTagRow = false;
        }
        if (value === "ContactRow") {
            this.transactionSummaryquery.sso = null;
            this.transactionSummaryquery.perNer = null;
            this.transactionSummaryquery.contact = null;
            this.contactFilter = null;
            this.showContactRowAll = true;
            this.showContactEditRow = false;
            this.showContactTagRow = false;
        }
        if (value === "ProcessedDateRangeRow") {
            this.transactionSummaryquery.processDateRangeStartDate = null;
            this.transactionSummaryquery.processDateRangeEndDate = null;
            this.showProcessedDateRangeRowAll = true;
            this.showProcessedDateRangeEditRow = false;
            this.showProcessedDateRangeTagRow = false;
        }
        if (value === "EventShowRow") {
            this.transactionSummaryquery.eventShow = null;
            this.showEventShowRowAll = true;
            this.showEventShowEditRow = false;
            this.showEventShowTagRow = false;
        }
        if (value === "WbseRow") {
            this.transactionSummaryquery.wbseCostCenter = null;
            this.showWbseRowAll = true;
            this.showWbseEditRow = false;
            this.showWbseTagRow = false;
            this.exportDisable = true;
        }
        if (value === "GlaccountRow") {
            this.transactionSummaryquery.glAccount = null;
            this.showGlAccountRowAll = true;
            this.showGlAccountEditRow = false;
            this.showGlAccountTagRow = false;
        }
        if (value === "AftraRow") {
          this.transactionSummaryquery.aftra = null;
          this.showAftraRowAll = true;
          this.showAftraEditRow = false;
          this.showAftraTagRow = false;
        }

        this.validForm();
    }

    onToggleFilterDatepicker($event) {
        this.transactionSummaryquery.dateRangeStartDate = $event[0];
        this.transactionSummaryquery.dateRangeEndDate = $event[1];
    }

    onToggleProcessedFilterDatepicker($event) {
        this.transactionSummaryquery.processDateRangeStartDate = $event[0];
        this.transactionSummaryquery.processDateRangeEndDate = $event[1];
    }

    removeTag(item, row, index) {
        if (row === "UnionCodeRow") {
            this.unionCodeList.splice(this.unionCodeList.indexOf(item), 1);
            this.selectedUnionCode.splice(
                this.selectedUnionCode.indexOf(item),
                1
            );
            item.value = !item.value;
        }
        if (row === "EmployeeTypeRow") {
            this.employeeTypeList.splice(
                this.employeeTypeList.indexOf(item),
                1
            );
            this.selectedEmployeeType.splice(
                this.selectedEmployeeType.indexOf(item),
                1
            );
            item.value = !item.value;
        }
        if (row === "SportsRow") {
            this.sportList.splice(this.sportList.indexOf(item), 1);
            this.selectedSport.splice(this.selectedSport.indexOf(item), 1);
            item.value = !item.value;
        }
        if (row === "NetworksRow") {
            this.networksList.splice(this.networksList.indexOf(item), 1);
            this.selectedNetwork.splice(this.selectedNetwork.indexOf(item), 1);
            item.value = !item.value;
        }
        if (row === "DayTypeRow") {
            this.dayTypeList.splice(this.dayTypeList.indexOf(item), 1);
            this.selectedDayType.splice(this.selectedDayType.indexOf(item), 1);
            item.value = !item.value;
        }
        if (row === "BURow") {
            //this.businessUnits.splice(this.businessUnits.indexOf(item), 1);
            this.selectedBU.splice(this.selectedBU.indexOf(item), 1);
            item.value = !item.value;
        }
        if (row === "AftraRow") {
          this.selectedAftra.splice(this.selectedAftra.indexOf(item), 1);
          this.selectedAftraItem = {};
        }
        this.showSection(row);
    }

    getDayTypes() {
        this.daytypes = [];
        this.subs.sink = this._lookupService.getDayTypes().subscribe(
            (result) => {
                this.daytypes = result.reference;
            },
            (err) => {
                this.log.showError(" got an error: ");
            },
            () => {}
        );
    }

    getNetworks() {
        this.networks = [];
        this.subs.sink = this._lookupService.getNetworks().subscribe(
            (result) => {
                this.networks = result.reference;
            },
            (err) => {
                this.log.showError(" got an error: ");
            },
            () => {}
        );
    }

    getEmployeeTypes() {
        this.employeetypes = [];
        this.subs.sink = this._lookupService.getEmployeeTypes().subscribe(
            (result) => {
                this.employeetypes = result.reference;
            },
            (err) => {
                this.log.showError(" got an error: ");
            },
            () => {}
        );
    }

    getSports() {
        this.sport = [];
        this.subs.sink = this._lookupService.getSports().subscribe(
            (result) => {
                this.sport = result.reference;
            },
            (err) => {
                this.log.showError(" got an error: ");
            },
            () => {}
        );
    }

    getUnionCode() {
        this.unioncodes = [];
        this.subs.sink = this._lookupService.getunionCodes().subscribe(
            (result) => {
                this.unioncodes = result.reference;
            },
            (err) => {
                this.log.showError(" got an error: ");
            },
            () => {}
        );
    }

    getBusinessUnits() {
        this.subs.sink = this.businessUnitService.get().subscribe({
            next: (result) => {
                this.allBusinessUnits = _.cloneDeep(result.reference);
                this.businessUnits = _.cloneDeep(result.reference);
            },
            error: (err) => {
                this.log.showError("Business Units failed to load");
            },
        });
    }

    onItemSelect(event) {
        this.selectedNetwork = event;
    }

    onDayTypeSelect(event) {
        this.selectedDayType = event;
    }

    onItemSelectBU(event) {
        this.selectedBU = event;
    }

    onItemSelectEmp(event) {
        this.selectedEmployeeType = event;
    }

    onItemSelectSport(event) {
        this.selectedSport = event;
    }
  onItemSelectUnionCode(event) {
        this.selectedUnionCode = event;
    }

  onChangeAftra(event) {
    if (!_.isNil(event)) {
      this.selectedAftra = [];
      this.selectedAftra.push(event);
    } else { this.selectedAftra = []; }
    }

    // Autocomplete of GL Account
    searchGlAccounts() {
        this.glAccountObservable$ = new Observable(
            (observer: Subscriber<string>) => {
                // Runs on every search
                observer.next(this.transactionSummaryquery.glAccount);
            }
        ).pipe(
            takeUntil(this.componentDestroyed$),
            switchMap((token: string) => {
                return this._lookupService.searchGlAccounts(
                    encodeURIComponent(token)
                );
            })
        );
    }

    onGLAccountValueSelected($event) {
        const glAccount = $event.item;
        this.transactionSummaryquery.glAccount = glAccount;
    }

    ////

    // Autocomplete of Contact Name
    searchContactName() {
        this.contactNameObservable$ = new Observable(
            (observer: Subscriber<string>) => {
                // Runs on every search
                observer.next(this.transactionSummaryquery.contact);
            }
        ).pipe(
            takeUntil(this.componentDestroyed$),
            switchMap((token: string) => {
                return this._lookupService.searchbynameHcmData(
                    encodeURIComponent(token)
                );
            })
        );
    }

    onContactNameValueSelected($event) {
        const contact = $event.item;
        this.transactionSummaryquery.contact = contact.fullName;
    }

    ////

    validForm() {
        if (
            (this.transactionSummaryquery.dateRangeStartDate !== null &&
                this.transactionSummaryquery.dateRangeEndDate !== null) ||
            this.selectedNetwork.length !== 0 ||
            this.selectedSport.length !== 0 ||
            this.transactionSummaryquery.eventShow !== null ||
            this.transactionSummaryquery.contact !== null ||
            this.selectedUnionCode.length !== 0 ||
            this.transactionSummaryquery.glAccount !== null ||
            this.selectedEmployeeType.length !== 0 ||
            this.transactionSummaryquery.wbseCostCenter !== null ||
            (this.transactionSummaryquery.processDateRangeStartDate !== null &&
                this.transactionSummaryquery.processDateRangeEndDate !== null &&
                this.selectedDayType.length !== 0)
        ) {
            this.exportDisable = false;
        } else {
            this.exportDisable = true;
        }
    }

    /// Export Functionality
    exporttransactionSummaryReport(query) {
        this.transactionSummaryquery.networks = this.selectedNetwork;
        this.transactionSummaryquery.daytypes = this.selectedDayType;
        this.transactionSummaryquery.sports = this.selectedSport;
        this.transactionSummaryquery.employeeType = this.selectedEmployeeType;
        this.transactionSummaryquery.unionCode = this.selectedUnionCode;
        this.transactionSummaryquery.aftra = this.selectedAftra;

        if (this.selectedBU && this.selectedBU.length > 0) {
            this.transactionSummaryquery.businessUnits = this.selectedBU;
        } else {
            this.transactionSummaryquery.businessUnits = this.allBusinessUnits;
        }
        //this.transactionSummaryquery.dateRangeStartDate = moment(this.transactionSummaryquery.dateRangeStartDate).format("MM/DD/yyyy");
        //this.transactionSummaryquery.processDateRangeStartDate = moment(this.transactionSummaryquery.dateRangeStartDate).format("MM/DD/yyyy");

        this.query = this._lookupService.getreportQuery(
            this.transactionSummaryquery,
            1,
            10000,
            10000,
            this.businessUnitId,
            this.departmentId
        );
        this.isDownload = true;
        this.subs.sink = this._lookupService
            .transactionSummaryReport(this.query, this.reportName)
            .subscribe({
                next: (data) => {
                    if (data == null) {
                        this.showAlertMessage = true;
                        this.log.clearAlert();
                        this.log.showModalError(
                            "There are no data points to export for this report at the moment."
                        );
                    } else {
                        //this.crewRateReport = this.getCriteriaData;
                        const fileName = "Transaction Summary Report";
                        const d = moment(new Date()).format("MM-DD-yyyy");
                        this.showAlertMessage = false;

                        this.child.fileName = fileName + d;
                        this.child.fileType = "excel";
                        this.child.data = data;
                        this.child.download();
                    }
                },
                error: (data) => {
                    this.showAlertMessage = true;
                    this.log.showModalError("Error Occurred");
                },
            });
    }

    onBusinessUnitSelected(data: any) {
        this.selectedBusinessUnit = data;
        this.businessUnitId = this.selectedBusinessUnit.id;
        this.selectedBU.push(this.selectedBusinessUnit);
    }

    buAccessSelected(data: any) {
        this.selectedBuAccess = data;
        this.departmentId = this.selectedBuAccess.departmentId;
    }

    subscribeEventHandlers() {
        this.subs.sink = this._sharedDataService
            .getSelectedBusinessUnit()
            .subscribe((selectedBu) => this.onBusinessUnitSelected(selectedBu));

        this.subs.sink = this._sharedDataService
            .getBuAccess()
            .subscribe(
                (access) => (this.buAccess = this.buAccessSelected(access))
            );
    }

    ngOnInit() {
        //this.getLookUpData();
        this.subscribeEventHandlers();
        this.getNetworks();
        this.getEmployeeTypes();
        this.getSports();
        this.getUnionCode();
        this.getDayTypes();
        this.searchGlAccounts();
        this.searchContactName();
        this.getBusinessUnits();
        this.transactionSummaryquery = {};
        this.transactionSummaryquery.dateRangeStartDate = null;
        this.transactionSummaryquery.dateRangeEndDate = null;
        this.transactionSummaryquery.networks = [];
        this.transactionSummaryquery.daytypes = [];
        this.transactionSummaryquery.sports = [];
        this.transactionSummaryquery.eventShow = null;
        this.transactionSummaryquery.contact = null;
        this.transactionSummaryquery.perNer = null;
        this.transactionSummaryquery.sso = null;
        this.transactionSummaryquery.unionCode = [];
        this.transactionSummaryquery.glAccount = null;
        this.transactionSummaryquery.employeeType = [];
        this.transactionSummaryquery.wbseCostCenter = null;
        this.transactionSummaryquery.wbseCostCenter = null;
        this.transactionSummaryquery.processDateRangeStartDate = null;
        this.transactionSummaryquery.processDateRangeEndDate = null;
        this.transactionSummaryquery.aftra = {};
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
